import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const RichTextDesignSettings = {
  'rich-text-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'rich-text-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'rich-text-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
}
